import React from 'react';
import { Radio, RadioGroup, withFormApi } from 'informed';
import PropTypes from 'prop-types';
import ComponentWithToken from './CompontentWithToken';
import { Card, FieldSet, KeyValue } from '../elements';
import PaymentPlans from './PaymentPlans';
import { formatCurrency, convertCurrencyValue } from '../../lib/utils';

class FinancePlansForm extends ComponentWithToken {
  state = {
    selectedFinancePlan: undefined,
  };

  onValueChange = (value) => {
    const { financePlans } = this.props;
    const selectedFinancePlan = financePlans.find(
      (financePlan) => financePlan.id === value
    );
    this.setState({ selectedFinancePlan });
  };

  getPlanValue = (planId) => {
    const { paymentPlans, financePlans } = this.props;
    if (paymentPlans.length === 0) {
      return 'Calculando...';
    }
    const payment_plans = paymentPlans.filter(
      (p) => +p.finance_plan === +planId
    );

    // Doc: Uma excessão para pegar os valores de planos que não tem parcelas
    // Inves de somar as parcelas, apenas pega o valor total do plano.
    if (payment_plans.length === 0) {
      const singlePlan = financePlans.filter(
        (p) => +p.id === +planId
      )

      return singlePlan.reduce(
        (accumulator, payment) =>
          accumulator + convertCurrencyValue(payment.value),
        0
      )
    };

    return payment_plans.reduce(
      (accumulator, payment) =>
        accumulator + convertCurrencyValue(payment.value),
      0
    );
  };

  render() {
    const { selectedFinancePlan } = this.state;
    const { financePlans, formApi, paymentPlans } = this.props;

    return (
      <>
        <FieldSet title="Dados Financeiros">
          <div className="list-base">
            <RadioGroup
              field="plan"
              onChange={() => formApi.setError('plan', null)}
              onValueChange={this.onValueChange}
            >
              {financePlans.map((financePlan) => (
                <Card>
                  <div style={{ padding: '2%' }}>
                    <label className="input-radio-type">
                      <Radio
                        value={financePlan.id}
                        id={`finance_plan-${financePlan.id}`}
                      />
                      <span
                        className={`radiomark ${
                          formApi.getError('plan') && 'radiomark-error'
                        } mt-0`}
                      />
                    </label>
                  </div>
                  <div className="enrollment-flex text-center">
                    <KeyValue title={financePlan.name} label="Plano" />
                    <KeyValue title={financePlan.due_date} label="Vencimento" />
                    <KeyValue title={financePlan.guarantors} label="Fiadores" />
                    <KeyValue
                      title={formatCurrency(this.getPlanValue(financePlan.id))}
                      label="Total"
                    />
                    <KeyValue
                      title={financePlan.installments}
                      label="Parcelas"
                    />
                  </div>
                </Card>
              ))}
            </RadioGroup>
          </div>
          <i className="helper">
            {selectedFinancePlan && selectedFinancePlan.message}
          </i>
        </FieldSet>
        <PaymentPlans
          financePlan={selectedFinancePlan}
          paymentPlans={paymentPlans}
        />
      </>
    );
  }
}

FinancePlansForm.propTypes = {
  financePlans: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      due_date: PropTypes.string,
      guarantors: PropTypes.number,
      value: PropTypes.string,
      installments: PropTypes.number,
      message: PropTypes.string,
    })
  ),
  formApi: PropTypes.shape({
    setError: PropTypes.func,
    getValue: PropTypes.func,
  }).isRequired,
  paymentPlans: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      date: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};

FinancePlansForm.defaultProps = {
  financePlans: [],
  paymentPlans: [],
};

export default withFormApi(FinancePlansForm);
